export default "__VITE_ASSET__B$97J7AW__"